import getEsQuery from '../esParser'

async function age (payload) {
  const jsonQuery = payload['query']

  const esSearch = getEsQuery(jsonQuery, payload)
  esSearch.aggs = getAgeAggregation()
  const url = `${process.env.ES_URL}/${process.env.LAS_INDEX}/_search`
  const auth = process.env.ES_AUTH
  const headers = { 'Content-Type': 'application/json' }
  if (auth) headers.Authorization = auth
  const results = await fetch(url, {method: 'POST', headers, body: JSON.stringify(esSearch)}).then(r => r.json())

  const aggregations = results.aggregations
  const numMonths = aggregations.months.buckets.length
  const data = aggregations.ages.buckets.map(a => ({ age: a.key, value: a.ue.value / numMonths }))
  // return { data }
  return {data: { data }}
}

function getAgeAggregation () {
  return {
    months: {
      date_histogram: {
        field: 'broadcastdate',
        interval: 'month',
        format: 'yyyy-MM'
      }
    },
    ages: {
      terms: {
        field: 'respondent.age'
      },
      aggs: {
        ue: {
          sum: {
            field: 'intabweight'
          }
        }
      }
    }
  }
}

export default age



// WEBPACK FOOTER //
// ./src/app/api/elasticsearch/LAS/age.js